import styled from "styled-components";
import SVG from "react-inlinesvg";

export const Container = styled.div`
    align-items: center;
    background: rgba(80, 80, 80, 0.7);
    display: ${({$Active})=> ($Active ? 'flex' : 'none')};
    height: 100vh;
    justify-content: center;
    position: fixed;
    transition: ease-out 0.8s;
    width: 100%;
    z-index: 9999;
`;

export const ContentContainer = styled.div`
    background: #FFF;
    border-radius: 21.913px;
    box-shadow: 1.461px 1.461px 0px 0px rgba(0, 0, 0, 0.25);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    max-height: 90%;
    padding: 30px;
    position: relative;
    width: 90%;
    @media (min-width: 720px) {
        height: ${props=> props.$height};
        min-width: 385px;
        width: ${props=> props.$width};
    }
`;

export const TitleContainer = styled.div`
    align-items: center;
    background: ${({ $background }) => $background ? $background : '#F6F6F6'};
    border-radius: 2.5px;
    box-shadow: 1.461px 1.461px 0px 0px rgba(0, 0, 0, 0.25);
    display: flex;
    height: max-content;
    justify-content: center;
    min-height: 65.739px;
    width: 100%;
`;

export const Title = styled.h1`
    color: ${({ $background }) => $background ? '#FFF' : '#333'};
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-align: center;
`;

export const ChildsContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 100%;
    margin-top: 20px;
    overflow: auto;
    width: 100%;
    &::-webkit-scrollbar {
        width : 7px;
    }
    &::-webkit-scrollbar-thumb {
        background: #ccc;
        border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background-color: #aaa
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    &::-webkit-scrollbar-button {
        display: none;
    }
`;

export const CloseIcon = styled(SVG)`
    width: 16px;
    height: 16px;
    & path {
        fill: currentColor;
    }
`;